import axios, { AxiosResponse } from 'axios';

export const apiSuccess = (response : AxiosResponse) : boolean =>
{
    console.log(`received response with status ${response.status}`);
    return response.status >= 200 && response.status < 300;
};